

<template>
  <Section
    modeOverride="generic"
    :title="title"
    iconClass="dollar-icon"
  >
    <template #icon>
      <DollarSignIcon/>
    </template>
    <template #content>
      <b-container fluid class="p-4 p-md-5">
        <b-row>
          <b-col
            class="mb-4 mb-md-0 justify-content-center flex-column d-flex"
            cols="24"
            :md="presentedByText ? 16 : 24"
            :lg="presentedByText ? 14 : 24"
          >
            <div>
              <p v-if="body" v-text="body"
                class="mx-auto mb-5 partner-ad-body"
              />
              <b-button
                variant="button"
                @click="onCTAButtonClick"
                :href="buttonUrl || BUYSIDE_URL"
                target="_blank"
                v-text="buttonText"
              />
            </div>
          </b-col>
          <b-col v-if="presentedByText" cols="24" md="8" lg="10" class="justify-content-center flex-column d-flex">
            <div>
              <p class="font-weight-normal" v-text="presentedByText"></p>
              <div class="text-center mx-auto">
                <VBImgFallback
                  fluid
                  :sources="imgSources"
                  style="max-height: 150px; max-width: min(100%, 150px);"
                />
              </div>
              <h6 class="nmls pt-3" v-if="nmlsLicense">
                <i>{{nmlsLicense}}</i>
              </h6>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </Section>
</template>

<script>
import Section from "@/components/shared/Section"
import DollarSignIcon from "@/../public/svg/DollarSign.svg"

const PLACEHOLDER_IMG = require('!!url-loader?limit=0!@/assets/presented_by.png')
const BUYSIDE_URL = 'http://www.getbuyside.com/';

export default {
  name: 'PartnerAd',
  components: {
    Section,
    DollarSignIcon
  },
  data: () => ({
    BUYSIDE_URL
  }),
  computed: {
    imgSources() {
      return [this.presentedByLogoImgSrc, PLACEHOLDER_IMG]
    }
  },
  methods: {
    onCTAButtonClick() {
      this.$gtag?.event("Learn More (To Lender Website): Partner Ad CTA", {
        'event_category': "Vue HVS",
        'event_label': window.location.origin
      })
    }
  },
  props: {
    title: {
      type: String,
      default: 'Need to finance that next home? We got you.'
    },
    body: {
      type: String
    },
    buttonText: {
      type: String,
      required: true,
      default: 'Click Here'
    },
    buttonUrl: {
      type: String,
      required: true
    },
    presentedByText: {
      type: String
    },
    presentedByLogoImgSrc: {
      type: String
    },
    nmlsLicense: {
      type: String
    }
  }
}
</script>

<style lang='scss' scoped>
@import '@/styles/_custom-variables.scss';
@import '@/styles/_custom-mixins.scss';

.nmls {
  color: $lightgraytext;
}

.partner-ad-body {
  max-width: 800px;
  text-align: center;
  line-height: 32px;
  font-size: 25px;
  color: #333;
  font-weight: 400;
}

</style>
